import { api, ApiError } from './api';

export interface FileResponse {
  fileKey: string;
}

export interface StorageUrlResponse {
  url: string;
}

export const files = {
  getStorageUrl: async (): Promise<StorageUrlResponse> => {
    try {
      const response = await api.get<StorageUrlResponse>('/files/storage-url');
      return response;
    } catch (error) {
      const apiError = error as ApiError;
      throw apiError;
    }
  },

  uploadImage: async (image: File): Promise<FileResponse> => {
    try {
      const formData = new FormData();
      formData.append('image', image);

      const response = await api.post('/files/image', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response;
    } catch (error) {
      const apiError = error as ApiError;
      throw apiError;
    }
  },

  uploadFile: async (file: File): Promise<FileResponse> => {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await api.post('/files', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response;
    } catch (error) {
      const apiError = error as ApiError;
      throw apiError;
    }
  },
};
